import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import { Observable, of } from "rxjs";
import { IAvailabilityInfo } from "../interfaces/IAvailabilityInfo";
import HttpClient from "./httpClient";
import EnvironmentService from "./environmentService";

export const ProductAvailabilityService = {
  get(
    dlvMode: string,
    apiName: string,
    altAddressRecId: string,
    items: { unitId: string; itemId: string }[],
    custAccount: string,
    state?: string,
    zipCode?: string,
  ): Observable<IAvailabilityInfo[]> {
    if (items.length === 0) {
      return of<IAvailabilityInfo[]>([]); // Return an empty array if there are no items to check availability for
    }

    if (IsEcom() || !EnvironmentService.get().getProductAvailabilityUrl) {
      return HttpClient.post({
        baseUri: ApiEndpointResolver.getProductAvailabilityUrl(
          dlvMode,
          apiName,
          altAddressRecId,
          state,
          zipCode,
        ),
        body: items,
      });
    } else {
      var itemLines = items.map((a) => {
        return { unitId: a.unitId, id: a.itemId };
      });

      var address = {
        state: state,
        zip: zipCode,
      };

      var requestBody = {
        dlvMode,
        custAccount,
        dealerConfigId: "WBM",
        itemLines,
        address,
      };

      return HttpClient.post({
        baseUri: ApiEndpointResolver.getProductAvailabilityUrl(),
        body: requestBody,
      });
    }
  },
};
